import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { saveWorkspaceId } from '@/utils/token';

const workspaceSlice = createSlice({
  name: 'wsPage/workspace',
  initialState: {
    wsList: undefined,
    ws: undefined,
    member: undefined,
    wsConfig: undefined,
    urlWsData: undefined
  },
  reducers: {
    getWsList: (state, action) => {
      if (!!action.payload) {
        return {
          ...state,
          wsList: action.payload,
        };
      }
    },
    getWs: (state, action) => {
      if (!!action.payload) {
        if (!_.isEmpty(action.payload?._id)) {
          saveWorkspaceId(action.payload?._id);
        }
        const ws = {
          _id: action.payload?._id,
          name: action.payload?.name,
          license_state: action.payload?.license_state,
          clinic: action.payload?.clinic
        }
        return {
          ...state,
          ws,
          member: action.payload?.member,
          wsConfig: action.payload?.config,
        };
      }
    },
    updateUrlWsData: (state, action) => {
      if (!!action.payload) {
        return {
          ...state,
          urlWsData: action.payload,
        };
      }
    },
    resetWsData: () => {
      return {
        wsList: undefined,
        ws: undefined,
        member: undefined,
        wsConfig: undefined,
        urlWsData: undefined
      };
    }
  },
});

export const { getWsList, getWs, updateUrlWsData, resetWsData } = workspaceSlice.actions;

export default workspaceSlice.reducer;
